export const MARKETING_STATS = {
  birdsLogged: '50K+',
  huntsLogged: '6.5K+',
  speciesLogged: '90+',
} as const
